export default __webpack_public_path__ + "static/media/donkey.29fcf2c1.png";